/* eslint-disable */
<template>
  <div class="login-panel">
    <links />
    <titlec />
    <div class="loginwidth">
      <p id="profile-name" class="profile-name-card"></p>
      <div v-if="showLoginForm">
        <div class="form-signin">
          <form>
            <span id="reauth-email" class="reauth-email"></span>
            <div class="entry">
              <labelc text="E-Mail" />
              <input
                type="email"
                autocomplete="off"
                placeholder="Email"
                v-model="email"
                @keydown.enter.prevent="$refs.passwordInput.focus()"
              />
              <labelc
                type="input-error"
                v-if="errors['email']"
                :text="errors['email'].text"
              />
              <buttonc
                type="input-error"
                icon="fa-exclamation-circle"
                v-bind:class="[errors['email'].type]"
                v-if="errors['email']"
                v-tooltip="errors['email'].tooltip"
              />
            </div>
            <div class="entry">
              <labelc text="Passwort" />
              <input
                type="password"
                placeholder="Passwort"
                ref="passwordInput"
                v-model="password"
                autocomplete="current-password"
                @keydown.prevent.enter="recaptchaLogin"
              />
              <labelc
                type="input-error"
                v-if="errors['password']"
                :text="errors['password'].text"
              />
              <buttonc
                type="input-error"
                icon="fa-exclamation-circle"
                v-bind:class="[errors['password'].type]"
                v-if="errors['password']"
                v-tooltip="errors['password'].tooltip"
              />
            </div>
          </form>
          <!--<div class ="mt-2">
                        <vue-recaptcha  align="center" ref="recaptcha" sitekey="6LeweXcUAAAAAEK3680JMMYmGxwPF5chsgypi_w7" @verify="onCaptchaVerified" @expired="onCaptchaExpired"></vue-recaptcha>
                    </div>-->
          <div class="footer no-divider">
            <div class="align-left" style="padding-right: 20px;">
              <a
                href="#"
                class="forgot-password"
                @click="OpenForgotPasswordPopup()"
              >
                Passwort vergessen?
              </a>
            </div>
            <div class="align-right" style="flex: initial">
              <buttonc
                v-if="!loading"
                type="rectangle green"
                label="Log in"
                @click="recaptchaLogin"
                style="width: 90px;"
              />
              <buttonc
                v-if="loading"
                type="rectangle green"
                icon="fa-spinner"
                style="width: 90px;"
              />
            </div>
          </div>
          <!--<div class="googleterms">
                    <p>This site is protected by reCAPTCHA and the Google
                        <a href="https://policies.google.com/privacy">Privacy Policy</a> and
                        <a href="https://policies.google.com/terms">Terms of Service</a> apply.
                    </p>
                  </div>-->
        </div>
        <!-- /form -->
      </div>
      <div>
        <form
          ref="redirectForm"
          id="redirectForm"
          style="display:none"
          action=""
          method="POST"
        >
          <input name="token" type="text" v-model="token" />
        </form>
      </div>
    </div>
    <!-- /card-container -->
    <v-dialog />
  </div>
  <!-- /container -->
</template>

<script>
import axios from "axios";
import dropdowncontainer from "../../components/uicomponents/dropdowncontainer.vue";
import labelc from "../../components/uicomponents/label.vue";
import buttonc from "../../components/uicomponents/button.vue";
import { Base64 } from 'js-base64';
export default {
  components: {
    dropdowncontainer,
    labelc,
    buttonc
  },
  name: "loginpanel",
  data() {
    return {
      email: "",
      password: "",
      twofactor: null,
      redirect: "",
      gcaptcha: "",
      token: "",
      showimg: false,
      showLoginForm: false,
      serviceimg: "logo",
      errors: {},
      loading: false
    };
  },
  created: function() {
    let view = this;
    this.email = this.$route.query.email;
    this.redirect = this.$route.query.redirect;
    this.setServiceImg();
    this.checkShowLoginForm();
    window.setTimeout(function() {
      view.loginWithToken();
    }, 500);
  },
  mounted() {
    /*console.log("AAA")
    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded')
    recaptchaScript.async = true;
    recaptchaScript.defer = true;
    document.head.appendChild(recaptchaScript); */
  },
  // methods that implement data logic.
  methods: {
    setServiceImg: function() {
      if (!this.isBlank(this.redirect)) {
        if (this.redirect.includes("mz")) {
          this.serviceimg = "mz";
        } else if (this.redirect.includes("mp")) {
          this.serviceimg = "mp";
        } else if (this.redirect.includes("mdcore")) {
          this.serviceimg = "md";
        } else {
          this.serviceimg = "logo";
        }
      } else {
        this.serviceimg = "logo";
      }

      this.showimg = true;
    },
    checkShowLoginForm: function() {
      if (
        this.supportsHTML5Storage() &&
        localStorage.getItem("md_token") != null
      ) {
        this.showLoginForm = false;
      } else {
        this.showLoginForm = true;
      }
    },
    isBlank: function(str) {
      return !str || /^\s*$/.test(str);
    },
    getQueryStringValue: function(key) {
      return decodeURIComponent(
        window.location.search.replace(
          new RegExp(
            "^(?:.*[&\\?]" +
              encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") +
              "(?:\\=([^&]*))?)?.*$",
            "i"
          ),
          "$1"
        )
      );
    },
    supportsHTML5Storage: function() {
      try {
        return "localStorage" in window && window["localStorage"] !== null;
      } catch (e) {
        return false;
      }
    },
    onCaptchaVerified(captcha) {
      this.gcaptcha = captcha;
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
      this.gcaptcha = "";
    },
    OpenForgotPasswordPopup() {
      let view = this;
      this.$helpers.OpenPopup({
        header: "Passwort zurücksetzen",
        width: "600px",
        components: [
          {
            type: "datafill",
            state: {
              entries: [
                {
                  key: "info",
                  type: "output",
                  value: "Bitte geben Sie die Email Adresse Ihres Accounts an:",
                  label: ""
                },
                {
                  key: "email",
                  type: "text",
                  value: view.email,
                  label: "",
                  placeholder: "E-Mail"
                }
              ],
              errorCheck: [
                entries => {
                  if (!view.$helpers.ValidEmailCheck(entries["email"]))
                    return {
                      key: "email",
                      type: "error",
                      text: "Falsche E-mail"
                    };
                  else return null;
                }
              ],
              selectCallback: (data, datafill) => {
                datafill.loading = true;
                view
                  .requestPasswordReset(data.email)
                  .then(response => {
                    view.toggleModal(
                      "Erfolg",
                      "<p>Eine Email zum Zurücksetzen des Passworts wurde versandt!</p>"
                    );
                    datafill.Toggle();
                  })
                  .catch(error => {
                    datafill.loading = false;
                    if (
                      error.response != undefined &&
                      error.response.data.message != undefined
                    ) {
                      datafill.errors = {};
                      datafill.errors["email"] = {
                        key: "email",
                        type: "error",
                        text: "Änderung konnte nicht durchgeführt werden",
                        tooltip:
                          "Bitte versuchen Sie es erneut oder kontaktieren Sie einen Administrator"
                      };
                    }
                  });
              }
            }
          }
        ],
        centered: true
      });
    },
    recaptchaLogin() {
      let view = this;
      this.loading = true;
      view.submitLogin();
      /*this.$recaptchaLoaded().then(() => {

        this.$recaptcha('login').then((token) => {
          view.gcaptcha = token;
          view.submitLogin();
        })
      }) */
    },
    submitLogin: function() {
      this.hideCustomModal("2FModal");
      if (
        !this.isBlank(this.password) &&
        !this.isBlank(this.email) /*&& !this.isBlank(this.gcaptcha)*/
      ) {
        this.modalMessage = "";
        this.modalPayload = "";
        let payload = {
          email: this.email,
          password: this.password,
          gcaptcha: "workaround" //this.gcaptcha
        };
        if (this.twofactor != null) {
          payload.twofactor = parseInt(this.twofactor);
        }
        let url = "/api/login";
        if (!this.isBlank(this.redirect)) {
          url = url + "?redirect=" + this.redirect + "&source=frontend";
        }
        let view = this;
        axios({
          method: "post",
          url: url,
          data: payload
        })
        .then(response => {
            //view.$refs.recaptcha.reset();
            view.token = response.data.token;
            let userAgreementSigned = response.data.userAgreementSigned;
            if (view.supportsHTML5Storage()) {
                if (userAgreementSigned) {
                    localStorage.setItem("md_token", view.token);
                }
            } else {
              // TODO: Handle case of browser not supporting local storage
            }
            if(userAgreementSigned){
                if (response.data.redirect != null) {
                    view.showLoginForm = false;
                    window.setTimeout(function() {
                        view.redirectTo(response.data.redirect);
                    }, 500);
                } else {
                    view.goToProfile();
                }
            } else {
                view.OpenUAPopup(false);
            }

        })
        .catch(function(error) {
            view.loading = false;

            view.twofactor = null;
            view.showLoginForm = true;
            if (
              error.response != undefined &&
              error.response.data.data.cause != undefined
            ) {
              let cause = error.response.data.data.cause;
              if (cause == "INVALID_CAPTCHA") {
                view.toggleModal(
                  "Fehler",
                  "Ungültiges Captcha, bitte versuchen Sie es erneut oder wenden Sie sich an einen Administrator.",
                  ""
                );
              } else if (cause == "NOT_ACTIVATED") {
                view.toggleModal(
                  "Fehler",
                  "Ihr Account wurde noch nicht aktiviert.",
                  "Bitte überprüfen Sie Ihr Email-Konto oder kontaktieren Sie einen Administrator."
                );
              } else if (cause == "MISSING_2F") {
                view.Open2FPopup();
              } else if (cause == "INVALID_2F") {
                view.toggleModal(
                  "Fehler",
                  "Ungültiger 2F Code, bitte versuchen Sie es erneut.",
                  ""
                );
              } else {
                view.errors = {};
                view.errors.password = {
                  type: "error",
                  text: "Bitte überprüfen Sie das Passwort"
                };
                //view.toggleModal('Fehler', 'Login fehlgeschlagen, bitte überprüfen Sie das Passwort.', '');
              }
            } else {
              view.errors = {};
              view.errors.password = {
                type: "error",
                text: "Bitte überprüfen Sie das Passwort"
              }; //view.toggleModal('Fehler', 'Login fehlgeschlagen, bitte überprüfen Sie das Passwort.', '');
            }
            /*if(reset_captcha){
            view.$refs.recaptcha.reset();
            view.gcaptcha='';
          }*/
        });
        } else {
            this.toggleModal(
            "Fehler",
            "Bitte geben Sie sowohl ihre Email Adresse als auch ihr Passwort ein!"
            );
        }
    },
    loginWithToken: function() {
      if (
        this.supportsHTML5Storage() &&
        localStorage.getItem("md_token") != null
      ) {
        this.modalMessage = "";
        this.modalPayload = "";

        let url = "/api/login?renew=true";
        if (!this.isBlank(this.redirect)) {
          url = url + "&redirect=" + this.redirect + "&source=frontend";
        }
        let view = this;
        let token = localStorage.getItem("md_token");
        axios({
          method: "get",
          url: url,
          headers: { Authorization: "Bearer " + token }
        })
        .then(response => {
            view.token = response.data.token;
            let userAgreementSigned = response.data.userAgreementSigned;
            if (view.supportsHTML5Storage()) {
                if (userAgreementSigned) {
                    localStorage.setItem("md_token", view.token);
                }
            } else {
              // TODO: Handle case of browser not supporting local storage
            }
            if(userAgreementSigned){
                if (response.data.redirect != null) {
                    view.showLoginForm = false;
                    window.setTimeout(function() {
                        view.redirectTo(response.data.redirect);
                    }, 500);
                } else {
                    view.goToProfile();
                }
            } else {
                view.OpenUAPopup(true);
            }
        })
        .catch(function(error) {
            console.error(error)
            view.showLoginForm = true;
            let reset_captcha = true;
            if (
              error.response != undefined &&
              error.response.data.data.cause != undefined
            ) {
              let cause = error.response.data.data.cause;
              if (cause == "TOKEN_EXPIRED") {
                view.toggleModal(
                  "Fehler",
                  "Ihr Login ist abgelaufen.",
                  "Bitte melden Sie sich erneut an."
                );
              } else if (cause == "NOT_ACTIVATED") {
                view.toggleModal(
                  "Fehler",
                  "Ihr Account wurde noch nicht aktiviert.",
                  "Bitte überprüfen Sie Ihr Email-Konto oder kontaktieren Sie einen Administrator."
                );
              } else {
                view.toggleModal(
                  "Fehler",
                  "Login fehlgeschlagen, bitte melden Sie sich erneut an.",
                  ""
                );
              }
            } else {
              view.toggleModal(
                "Fehler",
                "Login fehlgeschlagen, bitte melden Sie sich erneut an.",
                ""
              );
            }
            /*if(reset_captcha){
            view.$refs.recaptcha.reset();
            view.gcaptcha='';
          }*/
        });
      }
    },
    OpenUAPopup(tokenLogin = false){
        let view = this;
        view.showLoginForm = true;
        let header = "Nutzungsbedingungen akzeptieren";
        let description = "Um den Login-Prozess fortzuführen, ist es notwendig dass Sie unseren Nutzungsbedingungen zustimmen. <br/>"+
                          "Diese sind hier zu finden: <br/><ul style='list-style-type: none;'>"+
                          "<li><a target='_blank' rel='noopener noreferrer' href='https://www.meindienstplan.at/at/agb/MeinDienstplan_AGB.pdf'>AGB</a></li>"+
                          "<li><a target='_blank' rel='noopener noreferrer' href='https://www.meindienstplan.at/at/datenschutz/MeinDienstplan_DSV.pdf'>Datenschutzerklärung</a></li>"+
                          "</ul>"
        this.$helpers.OpenPopup({
            header: "Nutzungsbedingungen",
            width: "600px",
            components: [
            {
                type: "datafill",
                state: {
                    description: description,
                    entries: [
                        {
                        key: "agreement",
                        type: "bool",
                        value: false,
                        label: "Nutzungsbedinungen zustimmen",
                        }
                    ],
                    errorCheck: [
                        (entries) => {
                            if(!entries['agreement']){
                                return {key: 'agreement', type: 'error', label: null, text: 'Sie müssen unseren Nutzungsbestimmungen zustimmen bevor Sie sich einloggen können!'}
                            } else {
                                return null
                            }
                        }
                    ],
                    selectCallback: (data, datafill) => {
                        if(data.agreement){
                            view.updateUsgerAgreementDate()
                            .then(response => {
                                if(tokenLogin){
                                    view.loginWithToken();
                                } else {
                                    view.submitLogin();
                                }
                            }).catch(error => {
                                localStorage.removeItem("md_token");
                                view.toggleModal(
                                    "Fehler",
                                    "Login fehlgeschlagen, bitte melden Sie sich erneut an.",
                                    ""
                                );
                            })
                        } else {
                            localStorage.removeItem("md_token");
                        }
                    },
                    deleteCallback: () => {
                        localStorage.removeItem("md_token");
                    },
                    negativeButtonLabel: "Abbrechen",
                    positiveButtonLabel: "OK"
                }
            }
            ],
            centered: true
        });
    },
    Open2FPopup() {
      let view = this;
      this.$helpers.OpenPopup({
        header: "2F-Authentifizierung",
        width: "600px",
        components: [
          {
            type: "datafill",
            state: {
              entries: [
                {
                  key: "text",
                  type: "output",
                  value: "",
                  label: "Bitte geben Sie einen gültigen 2F Code ein: "
                },
                {
                  key: "twofactor",
                  type: "text",
                  value: "",
                  label: "",
                  placeholder: "Zwei Faktor Code",
                  submitOnEnter: true,
                  autofocus: true,
                }
              ],
              selectCallback: (data, datafill) => {
                view.twofactor = data.twofactor;
                view.submitLogin();
              },
              deleteCallback: () => {},
              negativeButtonLabel: "Abbrechen",
              positiveButtonLabel: "OK"
            }
          }
        ],
        centered: true
      });
    },
    updateUsgerAgreementDate: function(){
        let view = this;
        let claims = this.extractJWTInfo();
        var payload = {
            command: "updateUserAgreementDate",
            id: claims.id,
        }
        return axios({
            method: 'put',
            url: '/api/user',
            headers: {'Authorization': 'Bearer ' + this.token},
            data: payload
        })
    },
    requestPasswordReset: function(email) {
      this.hideCustomModal("requestPasswordModal");
      this.modalMessage = "";
      this.modalPayload = "";
      var payload = {
        command: "requestPasswordReset",
        email: email
      };
      let view = this;
      return axios({
        method: "put",
        url: "/api/user",
        data: payload
      });
    },
    redirectTo: function(url) {
      if (
        this.redirect.includes("mdpl") ||
        this.redirect.includes("ml") ||
        this.redirect.includes("mpweb") ||
        this.redirect.includes("promo")
      ) {
        window.location = url + "#/?jwt=" + this.token;
      } else {
        document.getElementById("redirectForm").setAttribute("action", url);
        this.$refs.redirectForm.submit();
      }
    },
    goToProfile: function() {
      let claims = this.extractJWTInfo();
      if (claims.id != undefined) {
        console.log("profile");
        this.$router.replace("/profile/" + claims.id);
      }
    },
    extractJWTInfo: function() {

      if (this.token){
        let str = this.token.split(".")[1]
        try {
            return JSON.parse(atob(str));
        } catch(error){
            return JSON.parse(Base64.decode(str));
        }

      }
      return {};
    },
    showCustomModal: function(modal) {
      this.$modal.show(modal);
    },
    hideCustomModal: function(modal) {
      this.$modal.hide(modal);
    },
    toggleModal(title, text, text2) {
      let view = this;
      this.$helpers.OpenInfoPopup(title, [text, text2], (entries, datafill) => {
        datafill.$parent.locked = false;
        datafill.$parent.Close();
        view.loading = false;
      });
    }
  },
  computed: {
    buttonStyle() {
      return {
        flex: `1 1 ${100 / 2}%`
      };
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login-panel {
  width: 498px !important;
  margin-top: -20px;
}

.googleterms {
  text-align: center;
  position: fixed;
  margin-top: 55px;
  width: 100vw;
  left: 0;
  right: 0;
  margin: 0 auto;
  margin-top: 55px;
}
.googleterms > * {
  color: var(--contrast-6);
  font-size: 10.8px;
  width: 100%;
  text-align: center;
}
.googleterms a {
  color: rgb(104, 145, 162);
}

.entry .label {
  width: 100px;
}

.footer {
  padding-top: 8px;
  margin-bottom: 9px;
}
</style>
